import React, { useState, useEffect, useRef, useContext, useCallback } from 'react';

import { uniqueId } from 'lodash'

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import AlertDialog from "../../widgets/AlertDialog";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Divider from '@material-ui/core/Divider';

import CircularProgress from '@material-ui/core/CircularProgress';

import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

import { ViewListItem, EditListItem } from './ListItems'

import moment from 'moment'
// store
import { ZoneContext } from "./store"
import actions from "./store/actions"

import globals from '../../globals'

// React-google-maps
import { withScriptjs, withGoogleMap, GoogleMap, Marker, Polyline, Polygon, OverlayView } from "react-google-maps"
const { MarkerClusterer } = require("react-google-maps/lib/components/addons/MarkerClusterer");
const { HausMap } = require('./HausMap')


const styles = {
    rowContainer: {
    	width: '100%',
    	display: 'flex',
    	flexDirection: 'row',
    	justifyContent: 'center',
    	alignItems: 'flex-start',
    	marginTop: '10px'
    },
    listContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginLeft: '10px',
        maxHeight: '100%',
        overflow: 'scroll'
    },
    listItem: {
    	display: 'flex',
    	justifyContent: 'center',
    	alignItems: 'center'
    },
    clickableListItem: {
    	display: 'flex',
    	justifyContent: 'center',
    	alignItems: 'center',
    	cursor: 'pointer'
    },
    error: {
    	color: 'crimson',
    	padding: '10px'
    }
};

// functional component
export default (props) => {

	const {state, dispatch} = useContext(ZoneContext)

	let { currentZones, activeZone, currentUserScreen, shootings, techs, selectedZones } = state

	// Non deleted zones
	let visibleZones = currentZones.filter(zone => 
		!(zone.hasOwnProperty('isRemoved') && zone['isRemoved'] == true) && 
		!(zone.hasOwnProperty('isHidden') && zone['isHidden'] == true)
	)
	
	const [saving, setSaving] = useState(false)
	const [error, setError] = useState(null)
	const [loading, setLoading] = useState(false)
	const [showError, setShowError] = useState(false)
	const [errorMessage, setErrorMessage] = useState("")
	const [tempListingsCount, setTempListingsCount] = useState({});
	const [originalCoordinates, setOriginalCoordinates] = useState(null);

	// Dropdown for zone type filter
	const [visibleZoneType, setVisibleZoneType] = useState(globals.zone_type.sales);
	const [brokerOffices, setBrokerOffices] = useState([]);

	useEffect(() => {
		loadZones();
		// Fetch broker office data on mount
		window.Hauslife.getBrokerOffices().then(res => {
			if (res && res.data) {
				setBrokerOffices(res.data);
			}
		});
	}, []) // The empty array causes this effect to only run on mount

	const loadZones = () => {
		window.Hauslife.getZones().then(zones => {
			let zonesWithRef = zones.map(zone => ({...zone, ref: React.createRef()}))
			dispatch({type: actions.FETCHING_ZONES_SUCCESS, data: zonesWithRef})
		})
	}

	const onCreateNewZone = () => {
		dispatch({type: actions.ADD_NEW_ZONE})
	}

	const onZoneSave = (newZoneName) => {
		let newZoneRef = activeZone.ref;
		let coords = newZoneRef.current.getPath().getArray();

		if(coords.length == 0) {
			setError("Please mark the zone on the map before saving it!")
			return;
		} else if(newZoneName.trim() == "") {
			setError("Please set the zone name before saving it!")
			return;
		} else {
			setError(null)
		}

		// Count broker office listings in this zone (sales mode only)
		let listingsInZone = null;
		if (visibleZoneType === globals.zone_type.sales && brokerOffices.length > 0) {
			const zonePolygon = new window.google.maps.Polygon({ paths: coords });
			listingsInZone = brokerOffices.filter(office => {
				const latLng = new window.google.maps.LatLng(parseFloat(office.lat), parseFloat(office.lng));
				return window.google.maps.geometry && window.google.maps.geometry.poly.containsLocation(latLng, zonePolygon);
			}).reduce((sum, office) => sum + (office.listing_count || 0), 0);
		}

		let zoneToSave = {
			zone_name: newZoneName,
			coordinates: coords,
			ref: newZoneRef,
			type: visibleZoneType // set type from dropdown
		};

		// Remove alert, just save

		if(activeZone.id != null) {
			// edit case
			zoneToSave['id'] = activeZone.id
			dispatch({type: actions.EDIT_ZONE_SAVE, data: zoneToSave})
		} else {
			// create zone
			zoneToSave['id'] = uniqueId("temp-")
			dispatch({type: actions.SAVE_NEW_ZONE, data: zoneToSave})
		}

		if (activeZone.id) {
			setTempListingsCount(prev => {
				const newState = { ...prev };
				delete newState[activeZone.id];
				return newState;
			});
		}
	}

	const onToggleZoneDelete = (event, zone) => {
		dispatch({type: actions.TOGGLE_DELETE_ZONE, data: zone})
	}

	const onZoneCancel = () => {
		if (activeZone.id && activeZone.ref && activeZone.ref.current && originalCoordinates) {
			const path = activeZone.ref.current.getPath();
			path.clear();
			
			// Add the original coordinates back
			originalCoordinates.forEach(coord => {
				path.push(new window.google.maps.LatLng(coord.lat, coord.lng));
			});
		}
		if (activeZone.id) {
			setTempListingsCount(prev => {
				const newState = { ...prev };
				delete newState[activeZone.id];
				return newState;
			});
		}
		setOriginalCoordinates(null);
		dispatch({type: actions.CANCEL_NEW_ZONE})
	}

	const onToggleZoneSelect = zone_id => {
		dispatch({type: actions.TOGGLE_ZONE_SELECTION, data: zone_id})
	}

	const onPolygonClick = (event, zone) => {
		console.log("poly clicked on map", zone)
		onToggleZoneSelect(zone.id)
	}

	const onZoneEdit = (event, zone) => {
		if (zone.coordinates && zone.coordinates.length > 0) {
			
			// Get the current path from the map ref if available, otherwise use stored coordinates
			let coordsToStore;
			if (zone.ref && zone.ref.current && zone.ref.current.getPath) {
				// Get the current coordinates from the map (most up-to-date)
				const currentPath = zone.ref.current.getPath().getArray();
				coordsToStore = currentPath.map(latLng => ({
					lat: latLng.lat(),
					lng: latLng.lng()
				}));
			} else {
				// Fallback to stored coordinates
				coordsToStore = zone.coordinates.map(coord => {
					if (typeof coord.lat === 'function' && typeof coord.lng === 'function') {
						return { lat: coord.lat(), lng: coord.lng() };
					} else {
						return { lat: coord.lat, lng: coord.lng };
					}
				});
			}
			
			setOriginalCoordinates(coordsToStore);
		}
		dispatch({type: actions.EDIT_ZONE, data: zone})
		console.log("zone clicked from map", zone)
	}

	const onToggleZoneVisibility = (zone) => {
		dispatch({type: actions.TOGGLE_ZONE_VISIBILITY, data: zone})
	}

	const onFetchShootings = () => {

		let zones = selectedZones.filter(zoneId => zoneId.toString().indexOf('temp') == -1)

		if(zones.length == 0) {
			return;
			// show some meaningful error alert
		}
		setLoading(true)
		window.Hauslife.getShootingsAndDepotsForZones(zones).then(result => {
			// let markers = shootings.data.data.map(shoot => shoot.listing).filter(({lat, lng}) => (lat != null || lng != null))
			if(result.shootings){
				dispatch({type: actions.FETCHED_SHOOTINGS, data: result.shootings})
			}
			if(result.techs){
				
				dispatch({type: actions.FETCHED_DEPOTS, data: result.techs})
			}
			setLoading(false)
		})
	}

	const saveToDB = () => {

		if(saving) {
			return;
		}

		setSaving(true)

		// Only zones with a real id and hasChanged go in changedZones
		let changedZones = currentZones
			.filter(zone => zone.hasOwnProperty('hasChanged') && zone.id && !zone.id.toString().startsWith('temp'))
			.map(zone => {
				let { ref, hasChanged, ...base} = zone

				let coordinates = base.coordinates.map(({lat, lng}) => ([lat(), lng()]))
				// add first coordinate at the end to make it circular
				coordinates.push([base.coordinates[0].lat(), base.coordinates[0].lng()])
				
				let geometry = {
					type: "Polygon",
					coordinates: [coordinates]
				}
				return {...base, coordinates: geometry};
			})

		// Only zones with a temp id go in newZones
		let newZones = currentZones
			.filter(zone => zone.id && zone.id.toString().startsWith("temp"))
			.map(zone => {
				let { ref, hasChanged, ...base} = zone

				let coordinates = base.coordinates.map(({lat, lng}) => ([lat(), lng()]))
				// add first coordinate at the end to make it circular
				coordinates.push([base.coordinates[0].lat(), base.coordinates[0].lng()])

				let geometry = {
					type: "Polygon",
					coordinates: [coordinates]
				}
				return {...base, coordinates: geometry};
			})

		let deletedZones = currentZones.filter(zone => (
								zone.hasOwnProperty('isRemoved') && 
								zone['isRemoved'] == true &&
								zone.id && !zone.id.toString().startsWith('temp')
							)).map(zone => zone.id)

		window.Hauslife.saveZonesToDB({"update": changedZones, "create": newZones, "delete": deletedZones}).then(result => {
			setSaving(false);

			if(result.data.status != 200){
				let errorMessage = "";

				if(result.data.status == 409 && result.data.shootings != null){
					errorMessage = "Veuillez assigner les captures suivantes avant de supprimer les zones:\n\n";

					result.data.shootings.forEach((shooting)=>{
						errorMessage += moment(shooting.scheduleddate).format("DD MMMM hh:mm") + ": " + shooting.listing.address + "\n";
					})
				}
				else if(result.data.status == 409 && result.data.userZones != null){
					console.log(result.data.userZones)
					errorMessage = "Veuillez changer la zone de couverture des utilisateurs suivants avant de poursuivre:\n\n";

					result.data.userZones.forEach((userZone)=>{
						errorMessage += userZone.user.firstname + " " + userZone.user.lastname + "\n";
					})
				}
				else{
					errorMessage = "An unexpected error has occured:\n\n";
					errorMessage += result.data.err;
				}
				setShowError(true);
				setErrorMessage(errorMessage);
			} else {
				// After saving, update temp ids to real ids in currentZones
				if (result.data.result) {
					let updatedZones = [...currentZones];
					result.data.result.forEach(res => {
						if (res.create) {
							// Find the temp zone by name and update its id
							let idx = updatedZones.findIndex(z => z.zone_name === res.create.zone_name && z.id && z.id.toString().startsWith('temp'));
							if (idx !== -1) {
								console.log("Updating zone id for:", updatedZones[idx].zone_name, "from", updatedZones[idx].id, "to", res.create.id);
								updatedZones[idx] = {
									...updatedZones[idx],
									id: res.create.id
							};
							}
						}
					});
					dispatch({type: actions.ON_SAVE_DB, data: result.data.result});
					// Optionally, update currentZones in state here if needed
				} else {
					dispatch({type: actions.ON_SAVE_DB, data: result.data.result});
				}
			}
		})
		.catch(err => {
			console.log("result from api", err)
			setSaving(false);
			setShowError(true);
			let errorMessage  = "An unexpected error has occured:\n\n";
			errorMessage += err;
			setErrorMessage(errorMessage);
		})
	}

	const alertClose = () => {
		setShowError(false)
		// loadZones();
		dispatch({type: actions.ON_SAVE_DB_FAILURE})
	}

	// Filter visible zones based on the dropdown
	let filteredZones = visibleZones;
	if (visibleZoneType) {
	    filteredZones = visibleZones.filter(zone => zone.type === visibleZoneType);
	}

	// Helper function to calculate listings and brokers with custom coordinates
	const getStatsInZoneWithCoords = (coordinates) => {
		if (visibleZoneType !== globals.zone_type.sales || brokerOffices.length === 0) return { listing_count: null, broker_count: null };
		const zonePolygon = new window.google.maps.Polygon({ paths: coordinates });
		let listing_count = 0;
		let broker_count = 0;
		brokerOffices.forEach(office => {
			const latLng = new window.google.maps.LatLng(parseFloat(office.lat), parseFloat(office.lng));
			if (window.google.maps.geometry && window.google.maps.geometry.poly.containsLocation(latLng, zonePolygon)) {
				listing_count += office.listing_count || 0;
				broker_count += office.broker_count || 0;
			}
		});
		return { listing_count, broker_count };
	};

	// Modified helper to get stats (checks temp state first)
	const getStatsInZone = (zone) => {
		if (zone.id === activeZone.id && currentUserScreen === 'edit' && tempListingsCount[zone.id] !== undefined && tempListingsCount[zone.id] !== null) {
			return tempListingsCount[zone.id];
		}
		if (visibleZoneType !== globals.zone_type.sales || brokerOffices.length === 0 || !zone.coordinates) return { listing_count: null, broker_count: null };
		const zonePolygon = new window.google.maps.Polygon({ paths: zone.coordinates });
		let listing_count = 0;
		let broker_count = 0;
		brokerOffices.forEach(office => {
			const latLng = new window.google.maps.LatLng(parseFloat(office.lat), parseFloat(office.lng));
			if (window.google.maps.geometry && window.google.maps.geometry.poly.containsLocation(latLng, zonePolygon)) {
				listing_count += office.listing_count || 0;
				broker_count += office.broker_count || 0;
			}
		});
		return { listing_count, broker_count };
	};

	const onZoneShapeChange = (zone) => {
		if(zone && zone.ref && zone.ref.current && zone.ref.current.getPath()) {
			const currentCoords = zone.ref.current.getPath().getArray();
			if (currentCoords && currentCoords.length > 0) {
				const stats = getStatsInZoneWithCoords(currentCoords);
				console.log('Updated stats:', stats);
				// Store the temporary stats for this zone
				setTempListingsCount(prev => ({
					...prev,
					[zone.id]: stats
				}));
			}
		}		
	}

	return (		
		<div style={styles.rowContainer}>
			<AlertDialog show={showError} didClose={alertClose} title={"Erreur lors de la supression de zone"} text={errorMessage} ></AlertDialog>
			<Grid item xs={12} sm={12} md={12}>
				<HausMap
	              googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCBlV8_octv2fJn5m6dAPJPn0UozRFm_q8&v=3.exp"
	              loadingElement={<div style={{ height: `${window.innerHeight - 200}px`, width: '100%' }} />}
	              containerElement={<div style={{ height: `${window.innerHeight - 200}px`, width:'100%' }} />}
	              mapElement={<div style={{ height: `${window.innerHeight - 200}px`, width:'100%' }} />}
	              polygons={filteredZones}
	              onPolygonClick={onPolygonClick}
	              userMode={currentUserScreen}
	              activeZone={activeZone}
	              selectedPolygonIdx={activeZone.id}
	              shootings={shootings}
	              depots={techs}
	              selectedZones={selectedZones}
	              // Show broker offices as markers if sales is selected
	              brokerOffices={visibleZoneType === globals.zone_type.sales ? brokerOffices : []}
				  onZoneShapeChange={onZoneShapeChange}
	            />
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
            	<div style={styles.listContainer}>
            		{/* Dropdown to select visible zone type */}
            		<div style={{display: 'flex', alignItems: 'center', marginBottom: 8}}>
            			<label htmlFor="zoneTypeSelect" style={{marginRight: 8}}>Afficher les zones de type:</label>
            			<select
            				id="zoneTypeSelect"
            				value={visibleZoneType}
            				onChange={e => setVisibleZoneType(Number(e.target.value))}
            				style={{marginRight: 8}}
            			>
            				<option value={globals.zone_type.photoshoot}>Photoshoot</option>
            				<option value={globals.zone_type.sales}>Sales</option>
            			</select>
            		</div>
            		<div style={{display: 'flex', flexDirection: 'row'}}>
            			<Button 
            				variant="contained" 
            				color="primary" 
            				onClick={saveToDB}
            				style={{margin: '10px', minWidth: '180px'}}
        				>
        					{	
        						saving == true ? <CircularProgress color="white" size={30} /> : <div>Save Zones to DB</div>
        					}
	                    </Button>
	                    <Button 
            				variant="contained" 
            				color="primary" 
            				onClick={onFetchShootings}
            				style={{margin: '10px', minWidth: '180px'}}
        				>
        					{	
        						loading == true ? <CircularProgress color="white" size={30} /> : <div>Fetch Markers</div>
        					}
	                    </Button>
            		</div>
            		{
                    	error &&
                    	<div style={styles.error}>{error}</div>
                	}
	            	<List style={{width:"100%"}}>
	            		<Divider />
	            		{
	            			currentUserScreen == 'create'
	            			? 	<EditListItem 
	            					onSave={onZoneSave}
	            					onCancel={onZoneCancel}
	            				/>
	            			: 	<ListItem>
									<ListItemText primary="Create New Zone" />
									<ListItemSecondaryAction style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start'}}>
										<AddCircleOutlineIcon color="primary" onClick={onCreateNewZone}/>
									</ListItemSecondaryAction>
	            				</ListItem>
            			}
            			<Divider />
	            		{

	            			filteredZones.map(zone => {
	            				let statsInZone = getStatsInZone(zone);
	            				// Show EditListItem if in edit mode and this is the active zone
	            				if(zone.id && (zone.id == activeZone.id) && currentUserScreen == 'edit') {
	            					return <EditListItem 
	            						zoneName={zone.zone_name}
		            					onSave={onZoneSave}
		            					onCancel={onZoneCancel}
		            					listingsInZone={visibleZoneType === globals.zone_type.sales && statsInZone.listing_count !== null ? statsInZone.listing_count : undefined}
		            					brokersInZone={visibleZoneType === globals.zone_type.sales && statsInZone.broker_count !== null ? statsInZone.broker_count : undefined}
	            						/>
	            				} else {
	            					return <ViewListItem 
		            							key={zone.id}
		            							zone={zone}
		            							onZoneEdit={onZoneEdit}
		            							onToggleZoneDelete={onToggleZoneDelete}
		            							onToggleZoneSelect={onToggleZoneSelect}
		            							checked={selectedZones.indexOf(zone.id) != -1}
		            							toggleZoneVisibility={onToggleZoneVisibility}
		            							listingsInZone={visibleZoneType === globals.zone_type.sales && statsInZone.listing_count !== null ? statsInZone.listing_count : undefined}
		            							brokersInZone={visibleZoneType === globals.zone_type.sales && statsInZone.broker_count !== null ? statsInZone.broker_count : undefined}
		            						/>
	            				}
	            			})
	        			}
	            	</List>
            	</div>
            </Grid>
      	</div>
	)
}